import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'Hope',
  slug: 'hope',
  category: 'Hope',
  date: '2025-05-16',
  image: '',
  excerpt: 'There is hope. Good reason for hope. Change is possible.',
  body: `There is hope. Good reason for hope. Change is possible.

Feeling lost is no fun. No good. Sometimes it's hard to find a reason for hope. Faith that the light at the end of the tunnel is NOT a train!

Talking with a coach can help you piece together the puzzle of life. Find out who you are. Who you want to be. Then help with a plan to get there and stay by your side as you put it all together.

There is good reason for hope. You don't have to stay lost. It takes work, but with the right help, the hardest work can seem easy.`,
}

export default post
